import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function RegisterCheckPage() {
  const { state } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div style={{padding: "2rem"}}>
        <div className="card" style={{ maxWidth: '45rem', width: "100%", marginInline: "auto"}}>
          <div className="card-header"><strong>Thank you!</strong></div>
          <div className="card-body">
            <div>Thank you for registering with epIMS!</div>
            <div>We need to verify you own the email address <strong>{state.email}</strong>.</div>
            <div>We have sent you an email with a confirmation link, please check your email and click the link.</div>
            <div>If you can't find the email please check your spam folder.</div>
          </div>
        </div>
      </div>
  );
}

export default RegisterCheckPage;
